import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";
import { MyContext } from "../../../pages/Funnel";
import { useContext } from "react";
import { FaArrowRightLong } from "react-icons/fa6";

const LiveVideo = ({ youtube_link }) => {
  const videoId = youtube_link.split("v=").pop();


  return (
    <div className="max-sm:px-5">
      {/* Responsive iframe wrapper */}
      <div className="max-w-2xl w-full mx-auto mt-10">
        <iframe
          className="w-full h-[30rem] max-sm:h-[24rem]"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen></iframe>
      </div>
      {/* <div className="max-w-2xl w-full mx-auto mt-10">
        <iframe
          width="853"
          height="480"
          src={`https://www.youtube.com/embed/${videoId}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div> */}

      <div className="flex justify-center">
        <PrimaryBtn className="bg-primary text-white flex gap-3 items-center px-6 py-3 rounded-md mt-7 mb-20 max-sm:text-sm">
          Join The Class <FaArrowRightLong />
        </PrimaryBtn>
        {/* <button
          style={{ backgroundColor: state.color }}
          className="bg-primary text-white flex gap-3 items-center px-6 py-3 rounded-md mt-7 mb-20 max-sm:text-sm">
          Join The Class <FaArrowRightLong />
        </button> */}
      </div>
    </div>
  );
};

export default LiveVideo;
